<div class="flex flex-column align-items-center">
    <p-button label="Volver al perfil" (onClick)="goToProfile()" class="m-3"></p-button>
    <h3>Tus estadísticas</h3>
    <p-selectButton id="timePeriods" [options]="timePeriods" optionLabel="name" optionValue="value" [ngModel]="selectedPeriod"
        (onChange)="changePeriod($event)"></p-selectButton>
</div>

<div class="flex flex-row flex-wrap justify-content-evenly align-items-start my-2 gap-3">
    <div class="flex flex-column align-items-center" *ngFor="let type of interactionTypes">
        <h4>{{ interactionOptions[type]['label'] }}</h4>
        <p-knob *ngIf="interactions" class="m-auto" [(ngModel)]="numberOfInteractions[type]" [max]="interactionsByType[type].length" 
            [readonly]="true" [size]="200" 
            textColor="{{ interactionOptions[type]['textColor'] }}" 
            valueColor="{{ interactionOptions[type]['valueColor'] }}" 
            rangeColor="{{ interactionOptions[type]['rangeColor'] }}" ></p-knob>
        <p *ngIf="interactionsByType[type].length === 0">Aún no hay datos</p>
        <p class="my-0 py-0" *ngIf="interactionsByType[type].length > 1">{{ interactionOptions[type]['first'] }}: 
            {{ interactionsByType[type][0].interactionDate }}</p>
        <p class="my-0 py-0" *ngIf="interactionsByType[type].length > 0">{{ interactionOptions[type]['last'] }}: 
            {{ interactionsByType[type][interactionsByType[type].length - 1].interactionDate }}</p>
    </div>
</div>

<div *ngIf="person && interactions" class="my-7 w-10 m-auto max-w-full">
    <app-timeline [person]="person" [interactions]="interactions"></app-timeline>
</div>